import React, { useEffect, useState } from "react";
import { Row, Col, Tooltip, Spin, message } from "antd";
import { ArrowLeftOutlined, MoreOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import Scrollbars from "react-custom-scrollbars";

import Logo from "../../../../assets/images/logo-without-bg.png";
import Logout from "../../../../assets/images/logout.png";
import unlinkTill from "../../../../assets/images/unlink-icon.svg";
import openDrawerIcon from "../../../../assets/images/openDrawer.svg";
import salesReportIcon from "../../../../assets/images/salesReportIcon.svg";

import SyncIcon from "../../Retail/SvgComponent/SyncIcon";
import TableDineIN from "../SvgComponents/TableDineIn";
import TableMenu from "../SvgComponents/TableMenu";
import TableCustomer from "../SvgComponents/TableCustomer";
import TableOrder from "../SvgComponents/TableOrder";
import CashManagementIcon from "../../Retail/SvgComponent/CashManagementIcon";

import { getMultilingualText } from "../../../../utils/getMultilingualText";
import { processSync } from "../../../Sync/syncData";
import db from "../../../../database";
import messages from "../../../../errors/messages.en-IN.json";
import useAuthStore from "../../../../stores/useAuthStore";
import useSyncProgressStore from "../../../../stores/useSyncProgressStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useSessionStore from "../../../../stores/useSessionStore";
import useRestaurantStore from "../../../../stores/useRestaurantStore";

const FBLeftSidebar = ({
  // State
  keyValue,
  setKeyValue,
  showMoreMenu,
  setShowMoreMenu,
  showOrderCompleteFlag,
  sortedSaleTypes,
  selectedSaleTypeIndex,
  setSelectedSaleTypeIndex,
  defaultSaleTypeIndex,
  fulfilmentIconMap,
  multilingual,
  posConfig,
  userData,
  tillaccess,
  cart,
  setCart,
  showSendToKitchen,
  hasUnfiredItems,
  splitBillScreen,
  clearCartData,
  showProducts,
  setShowProducts,
  handleSelectedSaleTypeForProducts,
  tillData,
  setSaleType,
  handleKeyvalue,
  setPaymentVisible,
  setSaleTypeProducts,
  // Reservations
  setReservationsBlank,
  loadReservations,
  loadWaitlistForUI,
  setWaitlistList,
  // History
  loading,
  setLoading,
  setShowOrderCompleteFlag,
  setSearchhistoryInput,
  setOrderHistoryDetails,
  setFiltersFlag,
  searchOrderHistory,
  // Sync
  setSyncLoad,
  setReloadTablesFlag,
  // Unlink Till
  isUnlinkTillClicked,
  handleUnlinkTillClick,
  // Sales Report
  CWHardwareController,
  salesReportCWHCPrinter,
  salesReportPrinter,
  // Call Center
  setIsCallCenterFlow,
  setShowCallCenterPage,
  // Logout
  tableCards,
  matchedRep,
  domainURL,
  // Router
  history,
}) => {
  const tenantLogoUrl = userData?.CW360_V2_UI?.appTheme?.tenant_logo;
  const [clientLogoFailed, setClientLogoFailed] = useState(false);

  useEffect(() => {
    setClientLogoFailed(false);
  }, [tenantLogoUrl]);

  return (
    <div
      data-zone="sidebar"
      data-zone-label="Sidebar"
      tabIndex={-1}
      style={{
        backgroundColor: "#fff",
        height: "100vh",
        width: "6.7%",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.15)",
        paddingLeft: "0.5vw",
        paddingRight: "0.5vw",
        display: showOrderCompleteFlag ? "none" : "",
      }}
    >
      <Row style={{ fontSize: "1vw" }}>
        <Col span={24} style={{ marginTop: "1.4vh" }}>
          <Tooltip title="Back to CW Browser">
            <button
              onClick={() => history.push("/")}
              style={{
                width: "100%",
                background: "#fff",
                color: "#ffffff",
                border: "1px solid #fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <img src={Logo} alt="CW Browser Home" style={{ height: "4.5vw" }} />
            </button>
          </Tooltip>
        </Col>
        {posConfig?.displayCompanyLogo === "Y" && tenantLogoUrl && !clientLogoFailed && (
          <Col span={24} style={{ marginTop: "0.6vh", display: "flex", justifyContent: "center" }}>
            <img
              src={tenantLogoUrl}
              alt="Client Logo"
              style={{ width: "90%", height: "auto" }}
              onError={() => setClientLogoFailed(true)}
            />
          </Col>
        )}
        <Scrollbars autoHide style={{ height: "78vh" }}>
          {!showMoreMenu ? (
            <>
              {sortedSaleTypes?.map((saleType, index) => {
                const fulfilmentType = saleType?.cwrSaletype?.fulfilmentType;
                const isSelected =
                  selectedSaleTypeIndex !== null ? selectedSaleTypeIndex === index : defaultSaleTypeIndex === index;
                const FulfilmentIcon = fulfilmentIconMap[saleType?.cwrSaletype?.fulfilmentType] || TableDineIN;
                return (
                  <Col
                    key={index}
                    id="step1"
                    span={24}
                    style={{
                      marginTop: "0.7vh",
                      display: posConfig?.enableDineIn === "Y" || posConfig?.enableTakeAway === "Y" || posConfig?.enableHomeDelivery === "Y" ? "block" : "none",
                    }}
                  >
                    <button
                      className="cartMenuItems"
                      style={{
                        display: saleType?.cwrSaletype?.fulfilmentType === "DI" ? (tillaccess?.dineIn === "Y" ? "block" : "none") : "block",
                        ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                        // display: accessController?.=== "N" ? "block" : "none",
                        // ...(keyValue === "0"
                        ...(isSelected
                          ? {
                              backgroundColor: "#2F3856",
                              border: "1px solid #2F3856",
                            }
                          : { backgroundColor: "#fff", border: "1px solid #fff" }),
                      }}
                      onClick={async () => {
                        if (cart.paid > 0) {
                          message.warning(`${messages.errors.till_management.delete_payment_method}`);
                          return;
                        }
                        if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                          message.warning(`${messages.errors.cart.cart_switch_section}`);
                          return;
                        }
                        if (showSendToKitchen && hasUnfiredItems) {
                          message.warning(`${messages.errors.cart.cart_switch_section}`);
                          return;
                        }
                        if (splitBillScreen) {
                          message.warning(messages.errors.cart.cart_switch_section);
                          return;
                        }
                        if (fulfilmentType === "TA") {
                          setCart(clearCartData);
                        }
                        setSelectedSaleTypeIndex(index);
                        setShowProducts(false);
                        await handleSelectedSaleTypeForProducts(saleType)();
                        const cartBase = fulfilmentType === "TA" ? clearCartData : useCartStore.getState().cart;
                        let updatedCart = {
                          ...cartBase,
                          customer: saleType.customer?.b2cCustomerId ? saleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
                          sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                          saleType: saleType?.cwrSaletype ?? {},
                        };
                        setCart(updatedCart);
                        // setSaleType("DI");
                        setSaleType(fulfilmentType);
                        // handleKeyvalue("0");
                        handleKeyvalue({ DI: "0", DE: "1", TA: "2" }[saleType?.cwrSaletype?.fulfilmentType], fulfilmentType);
                        setPaymentVisible(false);
                        setShowProducts(fulfilmentType === "TA");
                        if (fulfilmentType === "DI") {
                          setReloadTablesFlag((prev) => prev + 1);
                        }
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <FulfilmentIcon color={isSelected ? "#FFF" : "#555359"} />
                        <span
                          className="posIcon"
                          style={{
                            // color: keyValue === "0" ? "#fff" : "#555359",
                            // color: "#fff",
                            color: isSelected ? "#fff" : "#555359",
                            fontWeight: 500,
                          }}
                        >
                          {/* {getMultilingualText("Dine In")} */}
                          {saleType?.cwrSaletype?.name}
                        </span>
                      </div>
                    </button>
                  </Col>
                );
              })}

              {/* RESERVATIONS BUTTON */}
              <Col
                id="reservations"
                span={24}
                style={{ marginTop: "1vh", display: "block" }} // always show
              >
                <button
                  className="cartMenuItems"
                  style={{
                    ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                    ...(keyValue === "4" // highlight when selected
                      ? {
                          backgroundColor: "#2F3856",
                          border: "1px solid #2F3856",
                        }
                      : {
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                        }),
                  }}
                  onClick={async () => {
                    if (cart.paid > 0) {
                      message.warning(`${messages.errors.till_management.delete_payment_method}`);
                      return;
                    }
                    if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (showSendToKitchen && hasUnfiredItems) {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (splitBillScreen) {
                      message.warning(messages.errors.cart.cart_switch_section);
                      return;
                    }
                    setSelectedSaleTypeIndex(10);
                    // Set active button
                    handleKeyvalue("4");
                    setReservationsBlank(true);
                    loadReservations();
                    const list = await loadWaitlistForUI(); // get data
                    setWaitlistList(list);
                    // Your reservation page logic
                    // Example:
                    //history.push("/reservations");
                    // Or open your guest modal:
                    // setGuestsModalFlag(true)
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    {/* Use any icon you want */}
                    <TableMenu color={keyValue === "4" ? "#FFF" : "#555359"} />

                    <span style={{ color: keyValue === "4" ? "#fff" : "#555359", fontSize: "10px" }}>{getMultilingualText("Reservations")}</span>
                  </div>
                </button>
              </Col>
              {posConfig?.enablePreOrder === "Y" && (
                <Col
                  id="reservations"
                  span={24}
                  style={{ marginTop: "1vh", display: "block" }} // always show
                >
                  <button
                    className="cartMenuItems"
                    style={{
                      ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                      backgroundColor: "#fff",
                      border: "1px solid #fff",
                    }}
                    onClick={async () => {
                      if (cart.paid > 0) {
                        message.warning(`${messages.errors.till_management.delete_payment_method}`);
                        return;
                      }
                      if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (showSendToKitchen && hasUnfiredItems) {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (splitBillScreen) {
                        message.warning(messages.errors.cart.cart_switch_section);
                        return;
                      }
                      history.push("/restaurant/preorder");
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      {/* Use any icon you want */}
                      <TableMenu color={"#555359"} />

                      <span style={{ color: "#555359", fontSize: "10px" }}>{getMultilingualText("Pre-Order")}</span>
                    </div>
                  </button>
                </Col>
              )}
              {posConfig?.enableAggregator === "Y" && (
                <Col id="aggregator" span={24}>
                  <button
                    className="cartMenuItems"
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #fff",
                    }}
                    onClick={() => {
                      history.push("/aggregator");
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                      <img src={openDrawerIcon} style={{ height: "3vh" }} alt="" />
                      <span className="posIcon" style={{ color: "#555359" }}>
                        Aggregator
                      </span>
                    </div>
                  </button>
                </Col>
              )}
              {!multilingual && (
                <Col id="step5" span={24} style={{ marginTop: "2vh" }}>
                  <button
                    className="cartMenuItems"
                    style={{
                      ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                      ...(keyValue === "6"
                        ? {
                            backgroundColor: "#2F3856",
                            border: "1px solid #2F3856",
                            padding: "0",
                          }
                        : {
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                            padding: "0",
                          }),
                    }}
                    onClick={async () => {
                      const tables = await db.tableData.toArray();
                      const hasPendingBill = tables.some((table) => table.statusType === "OCU");

                      if (hasPendingBill) {
                        message.warning("Please complete the bill to proceed to Product sync", { duration: 10 });
                        return;
                      }
                      if (cart.paid > 0) {
                        message.warning(`${messages.errors.till_management.delete_payment_method}`);
                        return;
                      }
                      if (cart.items.length > 0 && (showProducts || keyValue === "2")) {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (showSendToKitchen && hasUnfiredItems) {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (splitBillScreen) {
                        message.warning(messages.errors.cart.cart_switch_section);
                        return;
                      }
                      handleKeyvalue("6");
                      setSyncLoad(true);
                      useSessionStore.getState().setLastUpdatedTime(null);
                      let tillData = useAuthStore.getState().tillData;
                      try {
                        await processSync(tillData, "Incremental Sync");
                        window.location.reload();
                      } catch (e) {
                        console.warn("[FBSidebar] Incremental sync failed:", e?.message);
                        message.error("Sync failed. Please check your network and try again.");
                      }
                      setSyncLoad(false);
                      useSyncProgressStore.getState().resetProgress();
                      setKeyValue("0");
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                      <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                        {getMultilingualText("Product Sync")}
                      </span>
                    </div>
                  </button>
                </Col>
              )}
              <Col id="step4" span={24} style={{ marginTop: "1vh" }}>
                <button
                  className="cartMenuItems"
                  style={{
                    ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                    ...(keyValue === "3"
                      ? {
                          backgroundColor: "#2F3856",
                          border: "1px solid #2F3856",
                          padding: "0",
                        }
                      : {
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                          padding: "0",
                        }),
                  }}
                  onClick={async () => {
                    setLoading(true); // Show loader immediately

                    try {
                      if (cart.paid > 0) {
                        message.warning(`${messages.errors.till_management.delete_payment_method}`);
                        return;
                      }
                      if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (showSendToKitchen && hasUnfiredItems) {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (splitBillScreen) {
                        message.warning(messages.errors.cart.cart_switch_section);
                        return;
                      }
                      setSelectedSaleTypeIndex(10);
                      handleKeyvalue("3");
                      setShowOrderCompleteFlag(false);
                      // deleteCart();
                      setPaymentVisible(false);
                      setShowProducts(false);
                      setSaleTypeProducts([]);
                      setCart(clearCartData);
                      setSearchhistoryInput("");
                      setOrderHistoryDetails([]);
                      setFiltersFlag(false);
                      const dateValue = [dayjs(new Date()), dayjs(new Date())];
                      setOrderHistoryDetails([]);

                      // Await if searchOrderHistory is async
                      await searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
                    } catch (error) {
                      console.error("Error processing click:", error);
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <TableOrder color={keyValue === "3" ? "#FFF" : "#fff"} />
                    <span className="posIcon" style={{ color: keyValue === "3" ? "#fff" : "#555359" }}>
                      {getMultilingualText("History")}
                    </span>
                  </div>
                </button>

                {loading && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 10000,
                    }}
                  >
                    <Spin size="large" />
                  </div>
                )}
              </Col>

              <Col id="moreMenuButton" span={24} style={{ marginTop: "1vh" }}>
                <button
                  className="cartMenuItems"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #fff",
                  }}
                  onClick={() => {
                    if (cart.paid > 0) {
                      message.warning(`${messages.errors.till_management.delete_payment_method}`);
                      return;
                    }
                    if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (showSendToKitchen && hasUnfiredItems) {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (splitBillScreen) {
                      message.warning(messages.errors.cart.cart_switch_section);
                      return;
                    }
                    setShowMoreMenu(!showMoreMenu);
                    //  setKeyValue("0");
                  }}
                >
                  <div>
                    <MoreOutlined style={{ color: "#555359" }} />
                    {/* <span className="posIcon" style={{ color: "#555359" }}>...</span> */}
                  </div>
                </button>
              </Col>
            </>
          ) : (
            <>
              {multilingual && (
                <Col id="step5" span={24} style={{ marginTop: "1.5vh" }}>
                  <button
                    className="cartMenuItems"
                    style={{
                      ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                      ...(keyValue === "6"
                        ? {
                            backgroundColor: "#2F3856",
                            border: "1px solid #2F3856",
                            padding: "0",
                          }
                        : {
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                            padding: "0",
                          }),
                    }}
                    onClick={async () => {
                      if (cart.paid > 0) {
                        message.warning(`${messages.errors.till_management.delete_payment_method}`);
                        return;
                      }
                      if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (showSendToKitchen && hasUnfiredItems) {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      handleKeyvalue("6");
                      setSyncLoad(true);
                      useSessionStore.getState().setLastUpdatedTime(null);
                      let tillData = useAuthStore.getState().tillData;
                      try {
                        await processSync(tillData, "Incremental Sync");
                        window.location.reload();
                      } catch (e) {
                        console.warn("[FBSidebar] Incremental sync failed:", e?.message);
                        message.error("Sync failed. Please check your network and try again.");
                      }
                      setSyncLoad(false);
                      useSyncProgressStore.getState().resetProgress();
                      setKeyValue("0");
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                      <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                        {getMultilingualText("Product Sync")}
                      </span>
                    </div>
                  </button>
                </Col>
              )}

              <Col id="unlinkTill" span={24} style={{ marginTop: "2vh" }}>
                <button
                  className="cartMenuItems"
                  style={{
                    ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                    ...(isUnlinkTillClicked
                      ? {
                          backgroundColor: "#2F3856", // Active background color
                          border: "1px solid #2F3856",
                        }
                      : {
                          backgroundColor: "#fff", // Default background color
                          border: "1px solid #fff",
                        }),
                  }}
                  onClick={handleUnlinkTillClick}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      src={unlinkTill}
                      style={{
                        height: "3vh",
                        filter: isUnlinkTillClicked
                          ? "brightness(0) invert(1)" // Makes the icon white when clicked
                          : "none", // Default icon color
                      }}
                      alt="unlink till"
                    />
                    <span
                      className="posMenuIcons"
                      style={{
                        color: isUnlinkTillClicked ? "#fff" : "#555359", // White text color when clicked, default otherwise
                      }}
                    >
                      {getMultilingualText("Unlink Till")}
                    </span>
                  </div>
                </button>
              </Col>

              <Col id="step5" span={24} style={{ marginTop: "0.5vh" }}>
                <button
                  className="cartMenuItems"
                  style={{
                    ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                    ...(keyValue === "6"
                      ? {
                          backgroundColor: "#2F3856",
                          border: "1px solid #2F3856",
                          padding: "0",
                        }
                      : {
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                          padding: "0",
                        }),
                  }}
                  onClick={async () => {
                    const tables = await db.tableData.toArray();
                    const hasPendingBill = tables.some((table) => table.statusType === "OCU");

                    if (hasPendingBill) {
                      message.warning("Please complete the bill to proceed to Full sync", { duration: 10 });
                      return;
                    }
                    if (cart.paid > 0) {
                      message.warning(`${messages.errors.till_management.delete_payment_method}`);
                      return;
                    }
                    if (cart.items.length > 0 && (showProducts || keyValue === "2")) {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (showSendToKitchen && hasUnfiredItems) {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    handleKeyvalue("6");
                    setSyncLoad(true);
                    useSessionStore.getState().setLastUpdatedTime(null);
                    let tillData = useAuthStore.getState().tillData;
                    try {
                      await processSync(tillData, "Full Sync");
                      window.location.reload();
                    } catch (e) {
                      console.warn("[FBSidebar] Full sync failed:", e?.message);
                      message.error("Sync failed. Please check your network and try again.");
                    }
                    setSyncLoad(false);
                    useSyncProgressStore.getState().resetProgress();
                    setKeyValue("0");
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                    <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                      {getMultilingualText("Full Sync")}
                    </span>
                  </div>
                </button>
              </Col>

              {/* <Col id="printReceipt" span={24} style={{ marginTop: "2vh" }}>
              <button
                className="cartMenuItems"
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #fff",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                  <img src={printerIcon} style={{ height: "3vh" }} alt="" />
                  <span className="posIcon" style={{ color: "#555359" }}>
                    {getMultilingualText("Print")}{" "}
                  </span>
                </div>
              </button>
            </Col> */}
              <Col id="step4" span={24} style={{ marginTop: "0.5vh", display: posConfig?.showCustomers === "Y" ? "block" : "none" }}>
                <button
                  className="cartMenuItems"
                  style={{
                    ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                    ...(keyValue === "8"
                      ? {
                          backgroundColor: "#2F3856",
                          border: "1px solid #2F3856",
                          padding: "0",
                        }
                      : {
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                          padding: "0",
                        }),
                  }}
                  onClick={() => {
                    if (cart.paid > 0) {
                      message.warning(`${messages.errors.till_management.delete_payment_method}`);
                      return;
                    }
                    if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (showSendToKitchen && hasUnfiredItems) {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (splitBillScreen) {
                      message.warning(messages.errors.cart.cart_switch_section);
                      return;
                    }
                    handleKeyvalue("8");
                    setPaymentVisible(false);
                    setShowProducts(false);
                    setSaleTypeProducts([]);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <TableCustomer color={keyValue === "8" ? "#FFF" : "#555359"} />
                    <span className="posIcon" style={{ color: keyValue === "8" ? "#fff" : "#555359" }}>
                      {getMultilingualText("Customers")}
                    </span>
                  </div>
                </button>
              </Col>
              <Col id="step3" span={24} style={{ marginTop: "3.5vh" }}>
                <button
                  className="cartMenuItems"
                  style={{
                    ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                    ...(keyValue === "5"
                      ? {
                          backgroundColor: "#2F3856",
                          border: "1px solid #2F3856",
                          padding: "0",
                        }
                      : {
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                          padding: "0",
                        }),
                  }}
                  onClick={() => {
                    if (cart.paid > 0) {
                      message.warning(`${messages.errors.till_management.delete_payment_method}`);
                      return;
                    }
                    if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (showSendToKitchen && hasUnfiredItems) {
                      message.warning(`${messages.errors.cart.cart_switch_section}`);
                      return;
                    }
                    if (splitBillScreen) {
                      message.warning(messages.errors.cart.cart_switch_section);
                      return;
                    }
                    handleKeyvalue("5");
                    setPaymentVisible(false);
                    setShowProducts(false);
                    setSaleTypeProducts([]);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <CashManagementIcon color={keyValue === "5" ? "#FFF" : "#555359"} />
                    <span
                      className="posMenuIcons"
                      style={{
                        color: keyValue === "5" ? "#fff" : "#555359",
                        paddingTop: "0px",
                      }}
                    >
                      {getMultilingualText("Cash Management")}
                    </span>
                  </div>
                </button>
              </Col>
              <Col
                id="salesReport"
                span={24}
                onClick={async () => {
                  try {
                    let ordersData = await db.ordersData.toArray();
                    ordersData = ordersData.filter((data) => data.tillStatus === "open");

                    if (CWHardwareController && typeof salesReportCWHCPrinter === "function") {
                      await salesReportCWHCPrinter(ordersData);
                    } else if (typeof salesReportPrinter === "function") {
                      await salesReportPrinter(ordersData);
                    } else {
                      console.error("Sales report printer functions not found");
                    }
                  } catch (err) {
                    console.error("Error while printing sales report:", err);
                  }
                }}
                style={{
                  cursor: "pointer",
                  display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                  marginTop: "2vh",
                }}
              >
                <button
                  className="cartMenuItems"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #fff",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img src={salesReportIcon} style={{ height: "3vh" }} alt="sales report" />
                    <span className="posIcon" style={{ color: "#555359" }}>
                      {getMultilingualText("Sales Report")}
                    </span>
                  </div>
                </button>
              </Col>
              {posConfig?.enableCallCentre === "Y" && (
                <Col span={24} style={{ marginTop: "0.5vh", display: "block" }}>
                  <button
                    className="cartMenuItems"
                    style={{
                      ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                      ...(keyValue === "9"
                        ? { backgroundColor: "#2F3856", border: "1px solid #2F3856", padding: "0" }
                        : { backgroundColor: "#fff", border: "1px solid #fff", padding: "0" }),
                    }}
                    onClick={async () => {
                      try {
                        // ----- 1. Guard clauses (keep them) -----
                        if (cart.paid > 0) {
                          message.warning(`${messages.errors.till_management.delete_payment_method}`);
                          return;
                        }
                        if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                          message.warning(`${messages.errors.cart.cart_switch_section}`);
                          return;
                        }
                        if (showSendToKitchen || splitBillScreen) {
                          message.warning(messages.errors.cart.cart_switch_section);
                          return;
                        }
                        setIsCallCenterFlow(true); // <-- this triggers the centered page
                        setShowCallCenterPage(true); // (optional) reset any other UI flags you use
                        // setKeyValue("10");
                        history.push("/call-center");
                      } catch (error) {
                        console.error("Call Center button error:", error);
                        message.error("An error occurred while switching to Call Center mode");
                      }
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <CustomerServiceOutlined style={{ color: keyValue === "9" ? "#FFF" : "#555359", fontSize: "3vh" }} />
                      <span className="posIcon" style={{ color: keyValue === "9" ? "#fff" : "#555359" }}>
                        {getMultilingualText("Call Center")}
                      </span>
                    </div>
                  </button>
                </Col>
              )}

              {/* Back Button to return to Main Menu */}
              <Col id="backButton" span={24} style={{ marginTop: "2vh" }}>
                <button
                  className="cartMenuItems"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #fff",
                  }}
                  onClick={() => {
                    (setShowMoreMenu(false), setKeyValue("0"));
                    setSelectedSaleTypeIndex(defaultSaleTypeIndex);
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                    {/* <BackIcon color="#555359" /> */}
                    <ArrowLeftOutlined style={{ color: "#555359" }} />
                    <span className="posIcon" style={{ color: "#555359" }}>
                      {getMultilingualText("Back")}
                    </span>
                  </div>
                </button>
              </Col>
              {/* <Col span={24} style={{ marginTop: "32vh" }}></Col> */}
            </>
          )}
        </Scrollbars>
      </Row>
      <Col span={24} style={{ position: "absolute", bottom: 0, marginLeft: "0.5vw" }}>
        <div id="step6">
          <button
            className="cartMenuItems"
            style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
            onClick={() => {
              const hasActiveTables = tableCards.some((t) => {
                if (t?.isSplitParent === "Y" && Array.isArray(t?.splitTables)) {
                  return t.splitTables.some((st) => st?.status !== "OPN");
                }

                return t?.statusType !== "OPN";
              });

              if (hasActiveTables) {
                message.warning("Some tables still have ongoing orders. Finish them to logout.");
                return;
              }
              if (cart.paid > 0) {
                message.warning(`${messages.errors.till_management.delete_payment_method}`);
                return;
              }
              if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
                message.warning(`${messages.errors.cart.cart_switch_section}`);
                return;
              }
              if (showSendToKitchen && hasUnfiredItems) {
                message.warning(`${messages.errors.cart.cart_switch_section}`);
                return;
              }
              let posConfig = usePOSConfigStore.getState().posConfig;
              if (matchedRep) {
                const clearCookiesAndLocalStorage = () => {
                  const cookies = document.cookie.split(";");

                  for (const cookie of cookies) {
                    const eqPos = cookie.indexOf("=");
                    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                    const domain = `domain=${domainURL}`;
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict; ${domain}`;
                  }

                  useSessionStore.getState().setTillSession(null);
                  useAuthStore.getState().logout();
                  window.location.assign("/sign-in");
                };
                clearCookiesAndLocalStorage();
              } else {
                if (posConfig?.shiftClose === "Y") {
                  if (posConfig?.showDenominations === "Y") {
                    history.push("/close-till");
                  } else if (posConfig?.showDenominations === "N") {
                    history.push("/close-till-all");
                  }
                } else {
                  useAuthStore.getState().logout();
                  window.location.assign("/sign-in");
                }
                handleKeyvalue("8");
              }
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <img src={Logout} style={{ height: "7vh" }} />
            </div>
          </button>
          {matchedRep && (
            <span
              style={{
                color: "#929098",
                fontWeight: 500,
                fontSize: "0.8em",
                textAlign: "center",
                paddingLeft: "0.3vw",
                paddingBottom: "0.5vh",
              }}
            >
              {matchedRep.name}
            </span>
          )}
        </div>
      </Col>
    </div>
  );
};

export default FBLeftSidebar;
